import { render, staticRenderFns } from "./ReportAd.vue?vue&type=template&id=22c61b8c"
import script from "./ReportAd.vue?vue&type=script&lang=js"
export * from "./ReportAd.vue?vue&type=script&lang=js"
import style0 from "./ReportAd.vue?vue&type=style&index=0&id=22c61b8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports